import { actions as formActions } from 'react-redux-form'

import * as h2Api from '../../h2Api'
import { ADMIN_PROFILE_NOTES_SAVED } from '../admin/adminLocalOpportunityActions'

export const CONTACT_LOOKUP_EMAIL = 'CONTACT_LOOKUP_EMAIL'
export const CONTACT_LOOKUP_RECORD = 'CONTACT_LOOKUP_RECORD'
export const CONTACT_SAVE_RECORD = 'CONTACT_SAVE_RECORD'
export const CONTACT_SUBMISSION_QUEUE = 'CONTACT_SUBMISSION_QUEUE'

export const COMPANY_LOAD = 'COMPANY_LOAD'

export const RETRIEVE_CLUSTERS = 'RETRIEVE_CLUSTERS'

export const contactIntakeModel = {
  id: '',
  firstName: '',
  lastName: '',
  email: '',
  officePhone: '',
  mobilePhone: '',
  position: '',
  address: '',
  city: '',
  state: '',
  zip: ''
}

export const companyIntakeModel = {
  companyName: '',
  companyUrl: '',
  companyLogoUrl: '',
  companyAbout: ''
}

export const participationIntakeModel = {
  notes: '',
  clusters: [],
  types: []
}

export const lookupContact = email => {
  return h2Api.post('/profiles/contacts/lookup', { email })({
    type: CONTACT_LOOKUP_EMAIL
  })
}

export const lookupRecord = recordId => {
  return h2Api.get(`/profiles/contacts/entry/${recordId}`)({
    type: CONTACT_LOOKUP_RECORD
  })
}

export const setContactEditForm = result => dispatch => {
  const model = 'localOpportunities.contactIntakeForm'

  dispatch(formActions.reset(model))
  const { additional, ...r } = result

  console.log(additional, result)
  const newModel = {
    ...contactIntakeModel,
    ...r
  }

  console.log(newModel)
  dispatch(formActions.change(model, newModel))
}

export const setCompanyEditForm = result => dispatch => {
  const model = 'localOpportunities.contactCompanyIntakeForm'

  dispatch(formActions.reset(model))
  console.log(result)
  const { additional, ...r } = result

  console.log(additional, result)
  const newModel = {
    ...contactIntakeModel,
    companyName: additional?.name,
    companyLogoUrl: additional?.logo,
    companyUrl: additional?.domain ? `https://${additional.domain}` : '',
    companyAbout: additional?.description,
    ...r
  }

  console.log(newModel)
  dispatch(formActions.change(model, newModel))
}

export const setParticipationForm = result => dispatch => {
  const model = 'localOpportunities.contactParticipationIntakeForm'

  console.log(result)
  dispatch(formActions.reset(model))
  dispatch(formActions.change(`${model}.notes`, result.notes))
  dispatch(formActions.change(`${model}.clusters`, result.clusters))
  dispatch(formActions.change(`${model}.types`, result.types))
}

export const saveRecord = (recordId, form) => {
  return h2Api.put(
    `/profiles/contacts/entry/${recordId}`,
    form
  )({ type: CONTACT_SAVE_RECORD })
}

/** The company part of the intake form, does not create a company */
export const saveCompany = (recordId, form) => {
  return h2Api.put(
    `/profiles/contacts/entry/${recordId}/company`,
    form
  )({ type: CONTACT_SAVE_RECORD })
}

export const submitRecord = (recordId, form) => {
  console.log(form)

  return h2Api.put(`/profiles/contacts/entry/${recordId}/complete`)({
    type: CONTACT_SAVE_RECORD
  })
}

export const contactAddNotes = (recordId, form) => {
  console.log(form)
  const formData = new FormData()
  const { file, ...other } = form

  Array.from(file).forEach(f => formData.append('file', f))
  formData.append('json', JSON.stringify({ ...other }))

  return h2Api.postFile(
    `/profiles/contacts/entry/${recordId}/notes`,
    formData
  )({ type: CONTACT_LOOKUP_RECORD })
}

export const loadQueue = () => {
  return h2Api.get(`/profiles/contacts/submissions`)({ type: CONTACT_SUBMISSION_QUEUE })
}

export const loadCompany = id => {
  return h2Api.get(`/profiles/admin/company/${id}`)({ type: COMPANY_LOAD })
}

export const loadWblType = id => {
  return h2Api.get(`/profiles/admin/offeringtype/${id}`)({ type: COMPANY_LOAD })
}

export const approveRecord = recordId => {
  return h2Api.post(`/profiles/contacts/submissions/${recordId}/convert`)({
    type: CONTACT_SUBMISSION_QUEUE
  })
}

export const loadClusterListing = profileId => {
  return h2Api.get(`/profiles/listclusters/${profileId}`)({ type: RETRIEVE_CLUSTERS })
}

/** The company part of the intake form, does not create a company */
export const saveParticipation = (recordId, form) => {
  console.log(recordId, form)
  const clusters = form.clusters.filter(f => f.selected).map(f => f.id)
  const types = form.types.filter(f => f.selected).map(f => f.id)

  return h2Api.put(`/profiles/contacts/entry/${recordId}/participation`, {
    clusters,
    types,
    notes: form.notes
  })({ type: CONTACT_SAVE_RECORD })
}
